/**
 * Time utility functions for consistent time handling across the app
 * All times are stored in UTC ISO format and displayed in local time
 */

/**
 * Formats a UTC timestamp to local time string
 * @param {string} utcTimeString - UTC ISO timestamp string
 * @returns {string} - Local time string in format like "2:30:45 PM"
 */
export const formatToLocalTime = (utcTimeString) => {
  if (!utcTimeString) return '';
  const date = new Date(utcTimeString);
  return date.toLocaleTimeString();
};

/**
 * Formats a UTC timestamp to local date string
 * @param {string} utcTimeString - UTC ISO timestamp string
 * @returns {string} - Local date string in format like "12/25/2023"
 */
export const formatToLocalDate = (utcTimeString) => {
  if (!utcTimeString) return '';
  const date = new Date(utcTimeString);
  return date.toLocaleDateString();
};

/**
 * Formats a UTC timestamp to local date and time string
 * @param {string} utcTimeString - UTC ISO timestamp string
 * @returns {string} - Local date and time string in format like "12/25/2023, 2:30:45 PM"
 */
export const formatToLocalDateTime = (utcTimeString) => {
  if (!utcTimeString) return '';
  const date = new Date(utcTimeString);
  return date.toLocaleString();
};

/**
 * Calculates the difference between a UTC timestamp and now in minutes
 * @param {string} utcTimeString - UTC ISO timestamp string
 * @returns {number} - Difference in minutes
 */
export const getMinutesFromNow = (utcTimeString) => {
  if (!utcTimeString) return 0;
  const startTime = new Date(utcTimeString);
  const now = new Date();
  return Math.floor((now - startTime) / 60000);
};

/**
 * Formats minutes into a human-readable wait time string
 * @param {number} minutes - Number of minutes
 * @returns {string} - Formatted string like "5m" or "65m"
 */
export const formatWaitTime = (minutes) => {
  if (minutes === 0) return '0m';
  return `${minutes}m`;
};

/**
 * Gets current time in UTC ISO format for storing in backend
 * @returns {string} - UTC ISO timestamp string
 */
export const getCurrentUTCTime = () => {
  return new Date().toISOString();
};